export default "__VITE_ASSET__d9J_MJBq__"